import React from "react";
import { useNavigate } from "react-router-dom";
import PageLayout from "examples/LayoutContainers/PageLayout";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function CommingSoon() {
  const navigate = useNavigate();

  return (
    <PageLayout>
      <MDBox
        height="100vh"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
        px={3}
      >
        <MDTypography variant="h3" gutterBottom>
          🚧 Coming Soon!
        </MDTypography>
        <MDTypography variant="body1" mb={3}>
          This section is under construction and will be available soon.
        </MDTypography>

        <MDButton
          variant="gradient"
          color="info"
          onClick={() => navigate(-1)} // Go back to previous page
        >
          ← Back
        </MDButton>
      </MDBox>
    </PageLayout>
  );
}

export default CommingSoon;
